import { render } from "./BaseViewIconButton.vue?vue&type=template&id=ca90ccb4&scoped=true"
import script from "./BaseViewIconButton.vue?vue&type=script&lang=js"
export * from "./BaseViewIconButton.vue?vue&type=script&lang=js"

import "./BaseViewIconButton.vue?vue&type=style&index=0&id=ca90ccb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca90ccb4"]])

export default __exports__